import { useEffect, useState } from 'react';

import { SessionBI } from '../types';

export const useWixRecorder = (sessionBI?: SessionBI) => {
  const [isLoaded, setIsLoaded] = useState(false);

  const isWixRecorderLoaded = () => typeof window !== 'undefined' && window.wixRecorder;

  useEffect(() => {
    const interval = setInterval(() => {
      if (isWixRecorderLoaded()) {
        setIsLoaded(true);
        clearInterval(interval);
      }
    }, 300);

    const timeout = setTimeout(() => {
      clearInterval(interval);
      console.warn('wix-recorder script failed to load within 2 minutes');
    }, 120000); // 2 minutes

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    const selfServiceSessionId = sessionBI?.selfServiceSessionId;
    if (!selfServiceSessionId || !isLoaded) {
      return;
    }

    if (isLoaded) {
      window.wixRecorder.addLabel('kb-client-nextjs');
      window.wixRecorder.addCustomAttribute('sessionId', selfServiceSessionId);
    }
  }, [sessionBI, isLoaded]);
};
